export type FormMessagesType = {
  submit: string
  stepMailTitle: string
  stepMailSubtitle: string
  stepContactInfoTitle: string
  stepContactInfoDescription: string
  stepSelectContentsTitle: string
  stepSelectContentsDescription: string
  stepSelectContentsViewOtherPapers?: string
  stepThanksTitle: string
  stepThanksSubtitle: string
  stepThanksDescription: string
  button: string
  buttons: string
  buttonMultiple: string
  stepThanksNewContactTitle: string
  stepThanksNewContactSubtitle: string
  stepThanksNewContactDescription: string
}
export type FormMessages = {
  errors: {
    minimumOneOption: string
    emailInvalid: string
  }
  gate: FormMessagesType
  insurtech: FormMessagesType
  bulletin: FormMessagesType
  paperDetail: FormMessagesType
}

export const formMessages: FormMessages = {
  errors: {
    emailInvalid: 'Please, use a corporate e-mail address',
    minimumOneOption: 'Please select at least one option'
  },
  paperDetail: {
    submit: 'Download White-paper',
    stepMailTitle: 'Get our White-paper',
    stepMailSubtitle: '',
    stepContactInfoTitle: 'One Step Away from your White Paper!',
    stepContactInfoDescription:
      'Please complete the following details to proceed',
    stepSelectContentsTitle: 'Choose Additional Resources',
    stepSelectContentsDescription: 'Enhance Your Knowledge',
    stepSelectContentsViewOtherPapers:
      "Did you find this interesting? Don't miss out on any of our latest publications, take a look at our full collection for more insights!",
    stepThanksTitle: 'Welcome back!',
    stepThanksSubtitle: '',
    stepThanksDescription:
      'We are glad to see you again and we hope you have found what you need.',
    button: 'Download White-paper',
    buttons: 'Download',
    buttonMultiple: 'Download White-paper',
    stepThanksNewContactTitle: 'Welcome to the NTT DATA Community!',
    stepThanksNewContactSubtitle: 'Your Download is Ready!',
    stepThanksNewContactDescription:
      'Please check your inbox; you should have received a message to verify your email address. Once verified, you will be part of our community and obtain up-to-date information, insights, and news about NTT DATA Insurance.'
  },
  gate: {
    submit: 'Download White-paper',
    stepMailTitle: 'Get our White-paper',
    stepMailSubtitle: '',
    stepContactInfoTitle: 'One Step Away from your White Paper!',
    stepContactInfoDescription:
      'Please complete the following details to proceed',
    stepSelectContentsTitle: 'Choose Additional Resources',
    stepSelectContentsDescription: 'Enhance Your Knowledge',
    stepSelectContentsViewOtherPapers:
      "Did you find this interesting? Don't miss out on any of our latest publications, take a look at our full collection for more insights!",
    stepThanksTitle: 'Welcome back!',
    stepThanksSubtitle: '',
    stepThanksDescription:
      'We are glad to see you again and we hope you have found what you need.',
    button: 'Download White-paper',
    buttons: 'Download',
    buttonMultiple: 'Download White-paper',
    stepThanksNewContactTitle: 'Welcome to the NTT DATA Community!',
    stepThanksNewContactSubtitle: 'Your Download is Ready!',
    stepThanksNewContactDescription:
      'Please check your inbox; you should have received a message to verify your email address. Once verified, you will be part of our community and obtain up-to-date information, insights, and news about NTT DATA Insurance.'
  },
  insurtech: {
    submit: 'Download the Insurtech 2025 Report',
    stepMailTitle: 'Get our Insurtech Global Outlook 2025 Report',
    stepMailSubtitle:
      'Through this form, you will be able to select which documents you want to download (multiple choice)',
    stepContactInfoTitle: 'Get our Insurtech Global Outlook 2025 Report',
    stepContactInfoDescription: 'You are about to download your Document(s)!',
    stepSelectContentsTitle: 'Get our Insurtech Global Outlook 2025 Report',
    stepSelectContentsDescription: 'Select your documents (Multiple choice)',
    stepThanksTitle: 'Welcome back!',
    stepThanksDescription:
      'We are glad to see you again and we hope you have found what you need.',
    button: 'Download White-paper',
    buttons: 'Download',
    buttonMultiple: 'Download your Document(s)',
    stepThanksNewContactTitle: 'Congratulations!',
    stepThanksNewContactSubtitle: 'Your paper is ready!',
    stepThanksNewContactDescription:
      'Please check your inbox; you should have received a message to verify your email address. Once verified, you will be part of our community and obtain up-to-date information, insights, and news about NTT DATA Insurance.',
    stepThanksSubtitle: '' // Not needed
  },
  bulletin: {
    submit: 'Subscribe',
    stepMailTitle: 'Join us!',
    stepMailSubtitle: 'Subscribe to our Bulletin',
    stepContactInfoTitle: 'You are almost subscribed!',
    stepContactInfoDescription: 'Please fill in the following fields',
    stepThanksTitle: 'You were already a subscriber!',
    stepThanksDescription:
      'Thank you very much for your interest. We hope you continue to enjoy our content and find it useful.',

    stepThanksNewContactTitle: 'Congratulations!',
    stepThanksNewContactDescription:
      'Please check your inbox; you should have received a message to verify your email address. Once verified, you will be part of our community and obtain up-to-date information, insights, and news about NTT DATA Insurance.',
    button: '', // Not needed
    buttonMultiple: '', // Not needed
    buttons: '', // Not needed
    stepSelectContentsTitle: '', // Not needed
    stepSelectContentsDescription: '', // Not needed
    stepThanksNewContactSubtitle: '', // Not needed
    stepThanksSubtitle: '' // Not needed
  }
}
